<script lang="ts" setup>
defineProps<{
    detected: boolean;
}>();
</script>

<template>
    <div class="scan-frame-overlay">
        <div class="scan-frame" :class="{ detected }">
            <div class="corner top-left"></div>
            <div class="corner top-right"></div>
            <div class="corner bottom-left"></div>
            <div class="corner bottom-right"></div>
        </div>
    </div>
</template>

<style scoped>
.scan-frame-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
}

.scan-frame {
    position: relative;
    width: 280px;
    height: 280px;
    box-shadow: 0 0 0 9999px rgba(0, 0, 0, 0.5);
    border-radius: 16px;
}

.corner {
    position: absolute;
    width: 40px;
    height: 40px;
    border-color: #fff;
    border-style: solid;
    border-width: 0;
    transition: border-color 0.2s ease;

    .detected & {
        border-color: #ff0000;
    }

    &.top-left {
        top: -4px;
        left: -4px;
        border-top-width: 4px;
        border-left-width: 4px;
        border-top-left-radius: 16px;
    }

    &.top-right {
        top: -4px;
        right: -4px;
        border-top-width: 4px;
        border-right-width: 4px;
        border-top-right-radius: 16px;
    }

    &.bottom-left {
        bottom: -4px;
        left: -4px;
        border-bottom-width: 4px;
        border-left-width: 4px;
        border-bottom-left-radius: 16px;
    }

    &.bottom-right {
        bottom: -4px;
        right: -4px;
        border-bottom-width: 4px;
        border-right-width: 4px;
        border-bottom-right-radius: 16px;
    }
}
</style>
